import { createFileRoute } from '@tanstack/react-router'
import { BookingMapTab } from '@/features/settings'

interface Search {
  by?: 'visit-type'
  hidden?: true
}

/** C-05 Booking map: `by` (default `location`) and `hidden` in the URL, defaults stripped (Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/map')({
  validateSearch: (raw: Record<string, unknown>): Search => ({
    ...(raw.by === 'visit-type' && { by: 'visit-type' as const }),
    ...((raw.hidden === true || raw.hidden === 'true' || raw.hidden === 1 || raw.hidden === '1') && {
      hidden: true as const,
    }),
  }),
  component: function BookingMapRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <BookingMapTab
        by={search.by ?? 'location'}
        showHidden={search.hidden ?? false}
        onSearch={(next) => {
          void navigate({
            search: (prev) => {
              const by = next.by ?? prev.by ?? 'location'
              const hidden = next.hidden ?? prev.hidden ?? false
              return { ...(by === 'visit-type' && { by }), ...(hidden && { hidden: true as const }) }
            },
            replace: true,
          })
        }}
      />
    )
  },
})
